import React from 'react';
import { Helmet } from 'react-helmet';

// By adding a preconnect link rel we will be establishing the dns-lookup, connection set up, and ssl negotiation well before our initial vistacart operations.
export const Preconnect = () => (
  <Helmet>
    <link
      rel="preconnect"
      href="https://vistacart.orders.vpsvc.com/health"
      crossOrigin="anonymous"
    />
  </Helmet>
);
